const t = "ticket_ICoum", _ = "ticket__header_HTVtY", c = "ticket__preHeaderWrapper_7UnmK", e = "ticket__heading_dFjKQ", i = "ticket__context_d6W8-", o = "ticket__context__scope_JqK-d", k = "ticket__timeContext_otOAW", r = "ticket__followBtn_glnWX", p = "ticket__productList_OC-eI", s = "ticket__product_0Jg3o", d = "ticket__product__modifier_mI767", n = "ticket__product__small_MiRDS", u = "ticket__product__quantity_8UMxo", a = "ticket__product__summary_b84vO", m = "ticket__product__price_WDsJi", l = "ticket__tuple_1WcGF", y = "ticket__summary_I2PVl", x = "ticket__total_Ihvpw", h = "ticket__total__summary_kjGow", W = {
  ticket: t,
  ticket__header: _,
  ticket__preHeaderWrapper: c,
  ticket__heading: e,
  ticket__context: i,
  ticket__context__scope: o,
  ticket__timeContext: k,
  ticket__followBtn: r,
  ticket__productList: p,
  ticket__product: s,
  ticket__product__modifier: d,
  ticket__product__small: n,
  ticket__product__quantity: u,
  ticket__product__summary: a,
  ticket__product__price: m,
  ticket__tuple: l,
  "ticket__tuple--voided": "ticket__tuple--voided_pOhaU",
  ticket__summary: y,
  ticket__total: x,
  ticket__total__summary: h
};
export {
  W as default,
  t as ticket,
  i as ticket__context,
  o as ticket__context__scope,
  r as ticket__followBtn,
  _ as ticket__header,
  e as ticket__heading,
  c as ticket__preHeaderWrapper,
  s as ticket__product,
  p as ticket__productList,
  d as ticket__product__modifier,
  m as ticket__product__price,
  u as ticket__product__quantity,
  n as ticket__product__small,
  a as ticket__product__summary,
  y as ticket__summary,
  k as ticket__timeContext,
  x as ticket__total,
  h as ticket__total__summary,
  l as ticket__tuple
};
//# sourceMappingURL=ticket.module.scss.js.map
